import { render, staticRenderFns } from "./DescriptionNew.vue?vue&type=template&id=1fb18a6b&"
import script from "./DescriptionNew.vue?vue&type=script&lang=js&"
export * from "./DescriptionNew.vue?vue&type=script&lang=js&"
import style0 from "./DescriptionNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports